/* global modForm modUtils */
import {
	addSharedResourceFileNamesToHeap,
	addRegressionTestingAttributes,
	addRequiredFieldsToForm,
	checkStartStep,
	generateSession,
	initAutofill,
	initCarousel,
	initFormElements,
	initFormSubmit,
	initHvacFuelTypeBlock,
	initLeadTokenScriptsTriggers,
	initNextButtonAbusePrevention,
	initNumericOnlyFields,
	initQSForm,
	saveQueryParamsCookie,
	initShowSecureText,
	initTooltips,
	initTrackZip1Change,
	initTrackZipChange,
	maskPhoneFields,
	prepopFormFromURL,
	trackMouseMovement,
	unmarkFieldAsInvalid,
	watchHashChange,
	updateTabIndexes,
	getEddieData,
	getSkipStepsConfig,
	deleteFormDataCookie,
	addServiceCodeToHeap,
	addSiteLabelToHeap,
	getFormData,
	trackTimeOnPage,
	initRecaptcha,
	trackPhoneValidityWithTrestle
} from '../../helpers';
import { isConfigValid } from '../../validators';

window.isNewModForm = true;

export function init(options) {
	modForm.opts = { ...modForm.opts, ...options };
	const formData = getFormData();
	modForm.opts.skipStepsConfig = Object.assign(getSkipStepsConfig(), modForm.opts.skipStepsConfig);
	modForm.opts.landingPageNoQuery = modForm.opts.landingPage.split('?')[0];
	modForm.opts.fullPageUrl = window.location.href;
	window.isNonTyp = true;
	modForm.opts.isModernize = /^(qa.)?modernize?-?\w+.com/ig.test(window.location.host);
	modForm.opts.isModernizeQuotePage = modForm.opts.isModernize && window.location.pathname.startsWith('/quote');
	modForm.opts.isLeadForm = window.location.pathname.includes('lead-form') || modForm.opts.isLeadWidget ? true : false;
	modForm.opts.isBranded = (formData && getFormData().Match) || (modForm.opts.form && modForm.opts.form.querySelector('input[name="Match"]') && modForm.opts.form.querySelector('input[name="Match"]').value) || window.location.host.includes('go.jacuzzi.com') ? true : false;
	modForm.opts.isBestCompany = window.location.host.includes('bestcompany');
	modForm.initialTrade = modForm.opts.vertical;

	deleteFormDataCookie();
	trackTimeOnPage.start();

	if (modForm.opts.useStepNameHash && window.location.hash !== '') {
		window.history.replaceState({}, document.title, window.location.href.split('#')[0]);
	}

	if (isConfigValid()) {
		// Init steps
		modForm.opts.steps = modForm.opts.form.querySelectorAll(modForm.opts.stepsSelector);
		// Init form elements
		initFormElements();

		// Make sure novalidate is set on the form to run our validation
		if (!modForm.opts.form.hasAttribute('novalidate')) {
			modForm.opts.form.setAttribute('novalidate', '');
		}

		// Assign URL GET params to modForm.opts.getVars
		modForm.opts.getVars = modUtils.getUrlParamsToObject(modForm.opts.landingPage);

		// Add required fields to the form
		addRequiredFieldsToForm();

		// get the eddie values and pre populate into the form
		getEddieData();

		// Prepop form from URL
		prepopFormFromURL();

		// Check if step directive is in the URL
		checkStartStep();

		addRegressionTestingAttributes();

		// Generate user session
		generateSession();

		initNextButtonAbusePrevention();

		const queryParams = modUtils.getUrlParamsToObject();
		const savedQueryParams = window.sessionStorage.getItem('queryParams');
		if (Object.keys(queryParams).length && (!savedQueryParams || savedQueryParams !== JSON.stringify(queryParams))) {
			saveQueryParamsCookie();
		}

		// Init if vertical = contractor
		if (modForm.opts.vertical === 'contractor') {
			modForm.initContractorForm();
			modForm.opts.useContractorApi = true;
		}

		// Init if it's a Quinstreet form
		if (modForm.opts.useQSApi) {
			initQSForm();
		}

		// Track Zip change by default if the value will be loaded from geolocation
		if (modForm.opts.zipField && modForm.opts.zipField.length && modForm.opts.zipField[0].getAttribute('data-geolocation')) {
			modForm.opts.initTrackZipChange = true;
		}

		if (modForm.opts.zipFormSelectorsToSync.length) {
			modForm.opts.trackZipChangeDynamically = true;
		}

		// Mask phone field & allow digits only
		initNumericOnlyFields(modForm.opts.maskedPhoneFields);
		maskPhoneFields(modForm.opts.maskedPhoneFields);

		// Numeric only fields
		initNumericOnlyFields(modForm.opts.numericsOnlyFields);

		// Remove error class when inputs change
		modForm.opts.form.addEventListener('input', function(e) {
			unmarkFieldAsInvalid(e.target);
		});
		if (modForm.opts.zipFormSelectorsToSync.length) {
			modForm.opts.zipFormSelectorsToSync.forEach(function(zipFormSelector) {
				const $zipForm = document.querySelector(zipFormSelector);
				if ($zipForm) {
					$zipForm.addEventListener('input', function(e) {
						unmarkFieldAsInvalid(e.target);
					});
				}
			});
		}

		// Init hvacFuelType block show/hide (HVAC only)
		if (modForm.opts.hvacVerticalName.toLowerCase() === modForm.opts.vertical.toLowerCase()) {
			initHvacFuelTypeBlock();
		}

		// Init form submit
		if (modForm.opts.useContractorApi) {
			modForm.initContractorFormSubmit(); // need to merge in mod-form
		} else {
			// Add TrustedForm Attributes
			if (modForm.opts.form) {
				modForm.opts.form.dataset.tfElementRole = 'offer';
			}

			if (modForm.opts.tcpaCopy?.[0]) {
				modForm.opts.tcpaCopy[0].dataset.tfElementRole = 'consent-language';
			}

			// Tasks to be done on interacting with the form
			modForm.opts.form.addEventListener('click', function() {
				if (window.innerWidth < 768) {
					updateTabIndexes();
				}
			}, { once: true });
			initFormSubmit();
		}

		// Init lead token scripts triggers
		initLeadTokenScriptsTriggers();

		// Init autofill
		if (modForm.opts.useAutofill) {
			initAutofill();
		}

		if (modForm.opts.hashStepTracking && modForm.opts.vertical !== 'contractor') {
			watchHashChange();
		}

		if (modForm.opts.useSmoothScrolling) {
			modUtils.initSmoothScrolling();
		}

		if (modForm.opts.useTooltips) {
			initTooltips();
		}

		if (modForm.opts.showSecureText) {
			initShowSecureText();
		}

		if (modForm.opts.trackZip1ChangeDynamically) {
			initTrackZip1Change();
		}

		if (modForm.opts.trackZipChangeDynamically) {
			initTrackZipChange();
		}

		// Check if we need to enable `autoHeight` on the carousel
		const $carousel = modForm.opts.formSwiperInstance?.$el ? modForm.opts.formSwiperInstance?.$el[0] : null;

		// If we got a valid carousel element, and that element has `swiper--dynamic-step-height` class, we need to enable `autoHeight`
		if ($carousel && $carousel.classList.contains('swiper--dynamic-step-height')) {
			modForm.opts.formSwiperInstance.params.autoHeight = true;

			// Enabling `autoHeight` on the carousel after it was instantiated does not adds the class, so adding it manually
			$carousel.classList.add('swiper-autoheight');

			modForm.opts.formSwiperInstance.updateAutoHeight();
		}

		if (modForm.opts.addAccessibilityUpdates) {
			trackMouseMovement();

			if (modForm.opts.useGlobalInitCarousel) {
				initCarousel();
			}
		}

		if (modForm.opts.useTrestleApiToTrackPhoneValidity) {
			trackPhoneValidityWithTrestle();
		}

		if (modForm.opts.showRecaptchaForDirectTraffic) {
			if (Object.keys(queryParams).length === 0) {
				modForm.opts.isDirectTraffic = true;
			} else {
				const excludeNativeParams = Object.keys(queryParams).filter(key => key !== 'zip' && key !== 'startStep');
				if (excludeNativeParams.length === 0) {
					modForm.opts.isDirectTraffic = true;
				}
			}

			window.onGrecaptchaLoad = function() {
				initRecaptcha();
			};
		}

		// Need to clear out the widget experience on back button (runs off a specific param)
		modUtils.refreshCachedExperienceOnBack();

		document.addEventListener('heap.loaded', function() {
			addSharedResourceFileNamesToHeap();
			addServiceCodeToHeap();
			addSiteLabelToHeap();
		});
	}
}
